import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
// @ts-ignore
import DOM from "../utils/dom";
import { Event } from "./events/event";
/**
 * The `BoxZoomHandler` allows the user to zoom the map to fit within a bounding box.
 * The bounding box is defined by clicking and holding `shift` while dragging the cursor.
 */

var BoxZoomHandler = /*#__PURE__*/function () {
  /**
   * @private
   */
  function BoxZoomHandler(map, options) {
    _classCallCheck(this, BoxZoomHandler);

    this.map = map;
    this.el = map.getCanvasContainer();
    this.container = map.getContainer();
    this.clickTolerance = options.clickTolerance || 1;
  }
  /**
   * Returns a Boolean indicating whether the "box zoom" interaction is enabled.
   *
   * @returns {boolean} `true` if the "box zoom" interaction is enabled.
   */


  _createClass(BoxZoomHandler, [{
    key: "isEnabled",
    value: function isEnabled() {
      return !!this.enabled;
    }
    /**
     * Returns a Boolean indicating whether the "box zoom" interaction is active, i.e. currently being used.
     *
     * @returns {boolean} `true` if the "box zoom" interaction is active.
     */

  }, {
    key: "isActive",
    value: function isActive() {
      return !!this.active;
    }
    /**
     * Enables the "box zoom" interaction.
     *
     * @example
     *   map.boxZoom.enable();
     */

  }, {
    key: "enable",
    value: function enable() {
      if (this.isEnabled()) {
        return;
      }

      this.enabled = true;
    }
    /**
     * Disables the "box zoom" interaction.
     *
     * @example
     *   map.boxZoom.disable();
     */

  }, {
    key: "disable",
    value: function disable() {
      if (!this.isEnabled()) {
        return;
      }

      this.enabled = false;
    }
  }, {
    key: "mousedown",
    value: function mousedown(e, point) {
      if (!this.isEnabled()) {
        return;
      }

      if (!(e.shiftKey && e.button === 0)) {
        return;
      }

      DOM.disableDrag();
      this.startPos = this.lastPos = point;
      this.active = true;
    }
  }, {
    key: "mousemoveWindow",
    value: function mousemoveWindow(e, point) {
      if (!this.active) {
        return;
      }

      var pos = point;

      if (this.lastPos.equals(pos) || !this.box && pos.dist(this.startPos) < this.clickTolerance) {
        return;
      }

      var p0 = this.startPos;
      this.lastPos = pos;

      if (!this.box) {
        this.box = DOM.create('div', 'l7-boxzoom', this.container);
        this.container.classList.add('l7-crosshair');
        this.fireEvent('boxzoomstart', e);
      }

      var minX = Math.min(p0.x, pos.x);
      var maxX = Math.max(p0.x, pos.x);
      var minY = Math.min(p0.y, pos.y);
      var maxY = Math.max(p0.y, pos.y);
      DOM.setTransform(this.box, "translate(".concat(minX, "px,").concat(minY, "px)"));

      if (this.box) {
        this.box.style.width = "".concat(maxX - minX, "px");
        this.box.style.height = "".concat(maxY - minY, "px");
      }
    }
  }, {
    key: "mouseupWindow",
    value: function mouseupWindow(e, point) {
      var _this = this;

      if (!this.active) {
        return;
      }

      if (e.button !== 0) {
        return;
      }

      var p0 = this.startPos;
      var p1 = point;
      this.reset();
      DOM.suppressClick();

      if (p0.x === p1.x && p0.y === p1.y) {
        this.fireEvent('boxzoomcancel', e);
      } else {
        this.map.emit('boxzoomend', new Event('boxzoomend', {
          originalEvent: e
        }));
        return {
          cameraAnimation: function cameraAnimation(map) {
            return map.fitScreenCoordinates(p0, p1, _this.map.getBearing(), {
              linear: true
            });
          }
        };
      }
    }
  }, {
    key: "keydown",
    value: function keydown(e) {
      if (!this.active) {
        return;
      }

      if (e.keyCode === 27) {
        this.reset();
        this.fireEvent('boxzoomcancel', e);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.active = false;
      this.container.classList.remove('l7-crosshair');

      if (this.box) {
        DOM.remove(this.box);
        this.box = null;
      }

      DOM.enableDrag(); // @ts-ignore

      delete this.startPos; // @ts-ignore

      delete this.lastPos;
    }
  }, {
    key: "fireEvent",
    value: function fireEvent(type, e) {
      return this.map.emit(type, new Event(type, {
        originalEvent: e
      }));
    }
  }]);

  return BoxZoomHandler;
}();

export default BoxZoomHandler;